// Copyright (c) 2017 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const OpenServiceIntervals = t.list(KeyValuePair, 'OpenServiceIntervals');

export const getDefaultState = () => new OpenServiceIntervals([]);

export default OpenServiceIntervals;



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/state/open-service-intervals.js